// extracted by mini-css-extract-plugin
export default {"iconHeader":"style_iconHeader__PBK3z"};